<template lang="html">
  <div class="monav_container">

    <div class="monav_button_wrap">
      <div class="monav_button" @click="monavTrig()">
        <div class="monav_button_container" v-bind:class="{ monav_open_class: monav }">
          <div class="monav_open monav_icon"><i class="fas fa-bars"></i></div>
          <div class="monav_close monav_icon"><i class="fas fa-times"></i></div>
        </div>
      </div>
      <div class="monav_logo" @click="redirectToHome()"></div>
    </div>

    <transition name="fadeleft" mode="out-in">
      <div class="monav_content" v-if="monav">
        <div class="monav_content_links">
          <router-link to="/" @click.native="monavTrig()">Home</router-link>
          <router-link to="/over" @click.native="monavTrig()">Over Ons</router-link>
          <router-link to="/portfolio" @click.native="monavTrig()">Portfolio</router-link>
          <router-link to="/contact" @click.native="monavTrig()">Contact</router-link>
        </div>
        <div class="monav_content_info">
          <h1>Contact Informatie</h1>
          <a href="tel:0297540055">0297-540055</a>
          <a href="mailto:vanden.wijngaart@hetnet.nl">vanden.wijngaart@hetnet.nl</a>
          <a href="geo:52.235530,4.824970">Zijdelveld 34-35, 1421 TJ Uithoorn</a>
        </div>
      </div>
    </transition>

    <transition name="fadetext" mode="out-in">
      <div class="monav_logo_naam" v-if="monav"><h1>J. van den Wijngaart</h1></div>
    </transition>

  </div>
</template>

<script>
export default {
  data() {
    return{
      monav: false,
    }
  },
  methods: {
    monavTrig() {
      this.monav = !this.monav;
    },
    redirectToHome() {
      this.$router.push({path: '/',})
      if (this.monav == true) {
        this.monav = !this.monav;
      }
    }
  }
}
</script>

<style lang="css">

.monav_content_info{
  display: flex;
  flex-direction: column;
  //background: #f1f1f1;
    border-radius: 5px;
    padding: 20px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.05), 0 3px 6px rgba(0,0,0,0.10);
}

.monav_logo_naam{
  position: fixed;
  z-index: 305;
  padding: 25px;
  height: 50px;
  display: flex;
  align-items: center;
}

.monav_logo_naam h1{
  font-size: 15px;
  color: #222;
}

.fadetext-enter-active{transition: 0.8s 0.1s ease;}
.fadetext-leave-active{transition: 0s ease;}

.fadetext-enter{transform: translateX(50px);opacity: 0;}
.fadetext-leave-active{transform: translateX(0px);opacity: 1;}

.monav_button_wrap{
  position: fixed;
  right: 0;
  margin: 25px;
  border-radius: 5px;
  display: flex;
  flex-direction: row-reverse;
  z-index: 310;
  overflow:hidden;
  box-shadow: 0 3px 6px rgba(0,0,0,0.05), 0 3px 6px rgba(0,0,0,0.10);
}

.monav_logo{
  width: 50px;
  height: 50px;
  background-image: url('../../assets/logo/jvdw_logo.png');
  background-position: center;
  background-size: 30px;
  background-repeat: no-repeat;
  background-color: rgba(255,255,255,0.9);
  cursor: pointer;
  transition: 0.3s ease;
}

.monav_logo:hover{
  transform: scale(1.1);
  transition: 0.3s ease;
}

.monav_content a{
    font-family: 'Segoe UI', sans-serif;
    font-size: 25px;
    color: #777;
    text-decoration: none;
    margin: 10px 0px;
    position: relative;
}

.monav_content a:after{
    position: absolute;
    background-color: #777;
    bottom: -5px;
    right: 0;
    content: ' ';
    height: 1px;
    width: 0%;
    transition: 0.4s ease;
}

.monav_content a:hover:after{
    left: 0;
    width: 100%;
    transition: 0.4s ease;
}

.router-link-exact-active{
    font-weight: 800;
    color: #222 !important;
}

.router-link-exact-active:after{
    content: ' ';
    background-color: #222 !important;
    width: 100% !important;
}

.monav_content_links{
  width: 100%;
  display: flex;
  flex-direction: column;
}

.fadeleft-enter-active,
.fadeleft-leave-active {
  transition: 0.3s ease;
}

.fadeleft-enter,
.fadeleft-leave-active {
  transform: translateX(50px);
  opacity: 0;
}

.monav_container{
  display: none;
}


@media only screen and (max-width : 650px) {
  .monav_container{
    display: flex;
    position: fixed;
    z-index: 300;
  }

  .monav_button{
    width: 50px;
    height: 50px;
    background: #fff;
    overflow: hidden;
  }

  .monav_button_container{
    display: flex;
    flex-direction: row;
    width: 120px;
    height: 50px;
    position: relative;
    left: 0;
    transition: 0.3s ease;
  }

  .monav_button_container:hover{
    cursor: pointer;
  }

  .monav_open{
    width: 50px;
    height: 50px;
  }

  .monav_close{
    width: 50px;
    height: 50px;
  }

  .monav_icon{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .monav_icon i{
    font-size: 25px;
    color: #222
  }

  .monav_open_class{
    left: -50px;
    transition: 0.3s ease;
  }

  .monav_content{
    box-sizing: border-box;
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    z-index: 301;
    background: #fff;
    padding: 90px 25px 25px 25px;
  }

  .monav_content_info a{
    font-size: 14px;
    margin: 5px 0;
  }

  .monav_content_info h1{
    font-size: 14px;
    font-family: 'Segoe UI', sans-serif;
    color: #222;
    padding-bottom: 10px;
    border-bottom: 1px solid #222;
    margin-bottom: 8px;
  }
}
</style>
